import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../service/user.service';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  isFormValid: boolean = false;
  form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  constructor(
    private readonly router: Router,
    private readonly usersService: UserService
  ) {
  }

  clearForm() {
    this.form.reset();
    this.isFormValid = false;
  }

  onSubmit() {
    console.log('onSubmit()', this.form);
    const username = this.form.get('email')?.value;
    const password = this.form.get('password')?.value;
    this.usersService.logIn(username, password).then(result => {
      console.log('login result', result);
      if (result.token != null) {
        this.router.navigate(['/']);
      } else {
        console.log('login failed, token is null');
      }
    }).catch(error => console.log('error', error));
  }

  ngOnInit() {
    this.form.valueChanges.subscribe(() => {
      this.isFormValid = this.form.valid;
    });
  }
}
